import { Button, DatePicker, Form, Input, Select } from 'antd'
import { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { removeVietnameseTones } from '../../config-func'
import { debounce } from 'lodash'
import dayjs from 'dayjs'
const { RangePicker } = DatePicker
const { Option } = Select

const SearchForm = ({
  fetchData,
  handleSearch,
  setFilters,
  listDepartment,
  setIsDisabled,
  defaultRange
}) => {
  const [form] = Form.useForm()
  const [dates, setDates] = useState(defaultRange)

  const handleReset = debounce(() => {
    setFilters({
      currentPage: 1,
      pageSize: 10,
      reset: uuidv4(),
      date: defaultRange
    })
    form.resetFields()
    form.setFieldsValue({ date: defaultRange })
    setIsDisabled(true)
  }, 300)

  const rangePresets = [
    { label: 'Hôm nay', value: [dayjs().startOf('day'), dayjs().endOf('day')] },
    {
      label: 'Tuần này',
      value: [dayjs().startOf('week'), dayjs().endOf('week')]
    },
    {
      label: 'Tháng này',
      value: [dayjs().startOf('month'), dayjs().endOf('month')]
    },
    {
      label: 'Năm nay',
      value: [dayjs().startOf('year'), dayjs().endOf('year')]
    }
  ]
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      style={{ marginTop: 10 }}
      initialValues={{ date: defaultRange }}
      onValuesChange={(value, allValues) => {
        setFilters((prev) => ({ ...prev, ...allValues }))
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
          alignItems: 'center'
        }}
      >
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="ID" name="text_search">
            <Input placeholder="Nhập tên hoặc id" />
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Sàn" name="department_id">
            <Select
              style={{ width: '100%' }}
              placeholder="Chọn sàn"
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
            >
              {/* <Option value="">Tất cả</Option> */}
              {listDepartment?.list?.map((item, idx) => (
                <Option key={idx} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item
            label="Thời gian"
            name="date"
            rules={[{ required: true, message: 'Vui lòng chọn thời gian' }]}
          >
            <RangePicker
              presets={rangePresets}
              // value={dates}
              allowClear={true}
              disabledDate={(current) => {
                if (!dates) return false
                const [start, end] = dates
                if (start && current.diff(start, 'day') > 60) return true
                if (end && end.diff(current, 'day') > 60) return true
                return false
              }}
              onCalendarChange={(val) => {
                setDates(val)
              }}
              onChange={(nextDates) => {
                const safeDates =
                  nextDates && nextDates.length ? nextDates : null
                setDates(safeDates)
                setFilters((prev) => ({
                  ...prev,
                  date: safeDates
                }))
                form.setFieldsValue({ date: safeDates })
              }}
              format="DD/MM/YYYY"
              style={{ width: '100%' }}
            />
          </Form.Item>
        </div>
        <div
          style={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'flex-end',
            flex: '1 1 200px',
            minWidth: '200px'
          }}
        >
          <Button onClick={handleReset}>Đặt lại</Button>
          <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }}>
            Tìm kiếm
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default SearchForm
